import { Component, OnInit, OnDestroy } from '@angular/core';
import { IxellAPIService, IColorUserV1, Roles, ICtcV1, DRStats, CountryStats } from '../../tools/api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Utils } from '../../tools/utils';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { StorageService } from '../../tools/storage.service';
import { Constants } from '../../entities/Constants';
import { HeaderService } from '../../tools/header.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-HistoColorUser',
    templateUrl: './histoColorUser.component.html',
    styleUrls: ['./histoColorUser.component.scss']
})
export class HistoColorUser implements OnInit, OnDestroy {

    displayedColumnsCTC = ["companySocialReason", "address", "city", "firstName", "name", "sended", "histo", "action"];
    displayedColumns = this.displayedColumnsCTC;
    displayedColumnsRT = ["CTCName", "companySocialReason", "address", "city", "firstName", "name", "sended", "histo", "action"];

    displayedColumnsCTCinfo = ["name", "firstName", "nbCreated", "nbSent", "histo"];
    displayedColumnsDRinfo = ["name", "nbCreated", "nbSent"];

    role: Roles;
    Roles = Roles;
    Utils = Utils;
    /* customers */
    customersLst: IColorUserV1[] = [];
    customersSource: any;
    /* DR */
    drLst: DRStats[] = [];
    drsSource: any;
    /* countries */
    countriesLst: CountryStats[] = [];
    countriesSource: any;
    /* CTC */
    ctcsLstDD: ICtcV1[] = [];
    ctcsLst: ICtcV1[] = [];
    ctcsSource: any;

    deleteMailCustomer: IColorUserV1;
    deleteAccountCustomer: IColorUserV1;
    countries: any[] = [];
    country: string;
    formCountry: string;
    countriesString: string = "";
    regions: DRStats[] = [];
    showDR: boolean = false;
    confirmationDeleteAccount: boolean = false;
    confirmationDeleteMail: boolean = false;
    ctcOpen: boolean = true;
    drOpen: boolean = true;
    colorUserOpen: boolean = true;

    /* Sub */
    private getCustomerSub: any;
    private regionsSub: any;
    private roleSub: any;
    private getCustomerCountrySub: any;
    private ctcSub: any;
    private GetStatsSub: any;
    private GetDRSub: any;
    private hiddeCustomerSub: any;
    private deleteDateMailSub: any;
    private countryStatsSub: any

    Form = new FormGroup({
        country: new FormControl('', [Validators.required]),
        region: new FormControl(''),
        ctc: new FormControl<number>(null)
    });

    constructor(private headerService: HeaderService, private apiServices: IxellAPIService, private storage: StorageService, private translateService: TranslateService) { }

    ngOnInit() {
        //let tmpCountries: any[] = Utils.countries();
        //let tmpCountries: any[];
        //if (Utils.isAdminRenault(this.role) || Utils.isAdminLacour(this.role)) {
        //  tmpCountries = Utils.countries();
        //} else {
        //  tmpCountries = Utils.countriesFiltered(this.country);
        //}
        //this.countries.push({ name: "", vo: "", txt: "shoppingcart.allBis" });
        //tmpCountries.forEach(c => {
        //  this.countries.push(c);
        //  this.countriesString += c.name + ",";
        //});

        this.headerService.changeCanBack(true);
        this.headerService.changeTitle(this.translateService.instant('manageaccount.histoTitle'));
        this.roleSub = this.headerService.currentRole.subscribe(role => this.role = role);
        this.country = this.storage.get("country");
        if (this.country == "null") { this.country = ""; }

        let tmpCountries: any[];
        if (Utils.isAdminRenault(this.role) || Utils.isAdminRenaultPays(this.role) || Utils.isAdminLacour(this.role)) {
            tmpCountries = Utils.countries();
            this.countries.push({ name: "", vo: "", txt: "shoppingcart.allBis" });
        } else {
            tmpCountries = Utils.countriesFiltered(this.country);
            this.Form.controls['country'].disable({ onlySelf: true });
        }
        tmpCountries.forEach(c => {
            this.countries.push(c);
            this.countriesString += c.name + ",";
        });

        this.Form.setValue({
            country: this.countries.find(c => c.name == this.country).name,
            region: '',
            ctc: 0
        });

        if (this.country && (this.country.toLowerCase() == "france" || this.country.toLowerCase() == "spain" || this.country.toLowerCase() == "united kingdom")) {
            this.getRegions(this.country);
        }
        else {
            this.GetData();
        }
    }

    GetData() {
        if (Utils.isCTC(this.role) && !(Utils.isFormateur(this.role) || Utils.isRT(this.role) || Utils.isAdminRenault(this.role) || Utils.isAdminRenaultPays(this.role) || Utils.isMCI(this.role))) {
            this.searchCustomer();
        }
        if (Utils.isFormateur(this.role) || Utils.isRT(this.role) || Utils.isAdminRenault(this.role) || Utils.isAdminRenaultPays(this.role) || Utils.isMCI(this.role)) {
            this.GetDRSub = this.apiServices.getDR().subscribe(data => {
                if (data && data.length > 0) {
                    if (Utils.isMCI(this.role) && !Utils.isRT(this.role))
                        data.forEach(d => {
                            let stat: DRStats = new DRStats();
                            stat.region = d;
                            this.regions.push(stat)
                        });

                    this.Form.controls["region"].setValue(data.length == 1 ? data[0] : '');
                    this.Form.controls["ctc"].setValue(0);

                    this.formCountry = this.Form.value.country;
                }
                if (!Utils.isAdminRenault(this.role) && !Utils.isAdminRenaultPays(this.role) && (Utils.isMCI(this.role) || Utils.isRT(this.role))) {
                    //this.Form.controls['country'].disable({ onlySelf: true });
                    //if (Utils.isMCI(this.role) && !Utils.isRT(this.role) && this.country.toLowerCase() == "france")
                    //this.Form.controls['region'].disable({ onlySelf: true });
                }
                this.getCTCs();
            });
        }
    }

    OpenCtcTable() {
        this.ctcOpen = !this.ctcOpen;
    }

    OpenDrTable() {
        this.drOpen = !this.drOpen;
    }

    OpenColorUserTable() {
        this.colorUserOpen = !this.colorUserOpen;
    }

    getTotalAccountActivated() {
        let total: number = 0;
        this.ctcsLst.forEach(c => total += c.stats.nbAccountActivated);
        return total;
    }

    getTotalAccountCreated() {
        let total: number = 0;
        this.ctcsLst.forEach(c => total += c.stats.nbAccountCreated);
        return total;
    }

    getTotalAccountTotal() {
        let total: number = 0;
        this.ctcsLst.forEach(c => total += c.stats.nbAccountTotal);
        return total;
    }

    getTotalAccountActivatedbyCountry() {
        let total: number = 0;
        this.countriesLst.forEach(c => total += c.nbAccountActivated);
        return total;
    }

    getTotalAccountCreatedbyCountry() {
        let total: number = 0;
        this.countriesLst.forEach(c => total += c.nbAccountCreated);
        return total;
    }

    getCTCs() {
        this.ctcOpen = true;
        let country: string;
        if (this.Form.value.country != '' && this.Form.value.country != undefined) {
            country = this.Form.value.country;
        }
        else {
            country = this.countries.find(c => c.name == this.country).name;
        }


        if (this.Form.value.country != "") {
            let region: string = this.Form.value.region;
            if (region && region.indexOf("manageaccount") >= 0)
                region = "";
            this.ctcSub = this.apiServices.getAllStatCtcByCountry(this.countries.find(c => c.name == country).name, region).subscribe(data => {
                if (data)
                    data.forEach(d => d.name = d.name.toUpperCase());
                this.ctcsLstDD = [];
                this.ctcsLst = data;
                this.ctcsLstDD.push(new ICtcV1());
                if (data)
                    data.forEach(d => this.ctcsLstDD.push(d));
                this.ctcsSource = new MatTableDataSource(this.ctcsLst);

                this.Form.controls["country"].setValue(country);
                this.Form.controls["ctc"].setValue(0);

                //if (!this.Form.controls["country"].disabled)
                this.formCountry = this.Form.value.country;

                let id: number;
                if (this.Form.value.ctc)
                    id = this.Form.value.ctc;
                else
                    id = 0;
                this.getCustomersByCountry(country, id, this.Form.controls["region"].value);
            }, error => {
                console.log(error);
                if (this.ctcSub != null) this.ctcSub.unsubscribe();
            });
        }
        else {
            this.countryStatsSub = this.apiServices.getCountriesStats(this.countriesString).subscribe(data => {
                if (data) {
                    this.countriesLst = [];
                    data.forEach(d => {
                        if (d.country && d.country != "")
                            this.countriesLst.push(d);
                    });
                    this.countriesLst.forEach(e => {
                        let tmp = this.countries.find(c => c.name == e.country);
                        if (tmp)
                            e.country = tmp.txt;
                    });
                    this.countriesSource = new MatTableDataSource(this.countriesLst);
                }
            }, error => {
                console.log(error);
                if (this.countryStatsSub != null) this.countryStatsSub.unsubscribe();
            });
        }
    }

    searchCustomer() {
        if (Utils.isCTC(this.role) && !(Utils.isFormateur(this.role)  || Utils.isRT(this.role) || Utils.isAdminRenault(this.role) || Utils.isAdminRenaultPays(this.role) || Utils.isMCI(this.role))) {
            this.getCustomersByCtcId();
        }
        if (Utils.isFormateur(this.role) || Utils.isRT(this.role) || Utils.isAdminRenault(this.role) || Utils.isAdminRenaultPays(this.role) || Utils.isMCI(this.role)) {
            this.getCTCs();
        }
    }

    selectCTC(event: any) {
        let id: number;
        let ctcsLstTmp: ICtcV1[] = [];
        if (event.value != "") {
            let ctc: ICtcV1 = this.ctcsLst.find(c => c.idCtc == Number.parseInt(event.value));
            ctcsLstTmp.push(ctc);
            id = this.Form.value.ctc;
        }
        else {
            ctcsLstTmp = this.ctcsLst;
            id = 0;
        }

        this.getCustomersByCountry(this.Form.controls["country"].value, id, this.Form.controls["region"].value);
        this.ctcsSource = new MatTableDataSource(ctcsLstTmp.slice());
    }

    sortCustomer(sort: Sort, status: string) {
        var data = this.customersLst;
        Constants.sortScale(sort, status, data);

        this.customersLst = data.slice();
        this.customersSource = new MatTableDataSource(this.customersLst);
    }

    sortCtc(sort: Sort, status: string) {
        var data = this.ctcsLst;
        Constants.sortScale(sort, status, data)

        this.ctcsLst = data.slice();
        this.ctcsSource = new MatTableDataSource(this.ctcsLst);
    }

    sortDR(sort: Sort, status: string) {
        var data = this.drLst;
        Constants.sortScale(sort, status, data)

        this.drLst = data.slice();
        this.drsSource = new MatTableDataSource(this.drLst);
    }

    sortCountries(sort: Sort, status: string) {
        var data = this.countriesLst;
        Constants.sortScale(sort, status, data)

        this.countriesLst = data.slice();
        this.countriesSource = new MatTableDataSource(this.countriesLst);
    }

    displayModal() {
        let modal = document.getElementById("Modal");
        modal.style.display = "block";
    }

    openDeleteAccountModal(customer: IColorUserV1) {
        this.confirmationDeleteAccount = true;
        this.deleteAccountCustomer = customer;
        this.displayModal();
    }

    hiddeCustomer() {
        this.hiddeCustomerSub = this.apiServices.hiddeCustomer(this.deleteAccountCustomer.idcolorUser, "HistoColorUser").subscribe(data => {
            if (data) {
                this.searchCustomer();
                this.closeModal();
            }
        }, error => {
            console.log(error);
            if (this.hiddeCustomerSub != null) this.hiddeCustomerSub.unsubscribe();
        });
    }

    openDeleteMailModal(customer: IColorUserV1) {
        this.confirmationDeleteMail = true;
        this.deleteMailCustomer = customer
        this.displayModal();
    }

    deleteDateMail() {
        this.deleteDateMailSub = this.apiServices.deleteDateMail(this.deleteMailCustomer.idcolorUser, "HistoColorUser").subscribe(data => {
            if (data) {
                this.searchCustomer();
                this.closeModal();
            }
        }, error => {
            console.log(error);
            if (this.deleteDateMailSub != null) this.deleteDateMailSub.unsubscribe();
        });
    }

    closeModal() {
        let modal = document.getElementById("Modal");
        modal.style.display = "none";
        this.deleteMailCustomer = new IColorUserV1();
        this.deleteAccountCustomer = new IColorUserV1();
        this.confirmationDeleteMail = false;
        this.confirmationDeleteAccount = false;
        this.searchCustomer();
    }

    getCustomersByCtcId() {
        this.colorUserOpen = true;
        this.getCustomerSub = this.apiServices.getColorUserByCtcID().subscribe(data => {
            this.customersSource = null;
            this.customersLst = data;
            if (this.customersLst.length > 0) {
                this.displayedColumns = this.displayedColumnsCTC;
                this.customersSource = new MatTableDataSource(this.customersLst.slice());
            }
        }, error => {
            console.log(error);
            if (this.getCustomerSub != null) this.getCustomerSub.unsubscribe();
        });
    }

    getCtcByCountry() {
        this.ctcsLst = [];
        this.ctcsSource = new MatTableDataSource(this.ctcsLst);
        this.customersLst = [];
        this.customersSource = new MatTableDataSource(this.customersLst);

        this.Form.controls["region"].setValue('');
        this.Form.controls["ctc"].setValue(0);

        this.formCountry = this.Form.value.country;
        if (this.Form.value.country != "")
            this.getRegions(this.countries.find(c => this.Form.value.country == c.name).name);
        else {
            this.countryStatsSub = this.apiServices.getCountriesStats(this.countriesString).subscribe(data => {
                if (data) {
                    this.countriesLst = [];
                    data.forEach(d => {
                        if (d.country && d.country != "")
                            this.countriesLst.push(d);
                    })
                    this.countriesLst.forEach(e => {
                        let tmp = this.countries.find(c => c.name == e.country);
                        if (tmp)
                            e.country = tmp.txt;
                    });
                    this.countriesSource = new MatTableDataSource(this.countriesLst);
                }
            }, error => {
                console.log(error);
                if (this.countryStatsSub != null) this.countryStatsSub.unsubscribe();
            });
        }
    }

    getRegions(country: string) {
        if (!country || country == "")
            country = this.Form.value.country;

        if (this.countries.findIndex(c => c.name == country) == -1)
            country = this.countries.find(c => c.name == country).name;

        this.Form.setValue({
            country: this.countries.find(c => c.name == country).name,
            region: '',
            ctc: 0
        });

        this.formCountry = this.Form.value.country;
        if (country && (country.toLowerCase() == "france" || country.toLowerCase() == "spain" || country.toLowerCase() == "united kingdom"))
            this.showDR = true;
        else
            this.showDR = false;
        this.regionsSub = this.apiServices.getRegionsWithStats(country).subscribe(data => {
            if (data) {
                this.drLst = [];
                this.regions = data;
                data.forEach(d => {
                    if (d.region != "")
                        this.drLst.push(d)
                });
                if (this.regions.length > 0)
                    this.regions.find(r => r.region == "").region = "manageaccount.allDR";

                this.drsSource = new MatTableDataSource(this.drLst.slice());
            }
            this.GetData();
            if (this.regionsSub != null) this.regionsSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.regionsSub != null) this.regionsSub.unsubscribe();
        });
    }

    getCustomersByCountry(country: string, ctcID: number, dr: string) {
        if (dr && dr.indexOf("manageaccount") >= 0)
            dr = "";
        this.getCustomerCountrySub = this.apiServices.getColorUserByCountryAndCTC(this.countries.find(c => c.name == country).name, ctcID, dr).subscribe(data => {
            if (data) {
                this.customersSource = null;
                this.customersLst = data;
                if (this.customersLst.length > 0) {
                    this.displayedColumns = this.displayedColumnsCTC;
                    this.customersSource = new MatTableDataSource(this.customersLst.slice());
                }
            }
        }, error => {
            console.log(error);
            if (this.getCustomerCountrySub != null) this.getCustomerCountrySub.unsubscribe();
        });
    }

    ngOnDestroy() {
        if (this.regionsSub != null) this.regionsSub.unsubscribe();
        if (this.roleSub != null) this.roleSub.unsubscribe();
        if (this.getCustomerSub != null) this.getCustomerSub.unsubscribe();
        if (this.getCustomerCountrySub != null) this.getCustomerCountrySub.unsubscribe();
        if (this.ctcSub != null) this.ctcSub.unsubscribe();
        if (this.GetStatsSub != null) this.GetStatsSub.unsubscribe();
        if (this.GetDRSub != null) this.GetDRSub.unsubscribe();
        if (this.hiddeCustomerSub != null) this.hiddeCustomerSub.unsubscribe();
        if (this.deleteDateMailSub != null) this.deleteDateMailSub.unsubscribe();
        if (this.countryStatsSub != null) this.countryStatsSub.unsubscribe();
    }
}
